// @flow
import { redirect } from 'react-router-dom';
import { selectUser } from '../stores/auth';

const buildRedirectUrl = (pathname: string, search: string, config: any) => {
  const path = encodeURIComponent(`${pathname}${search}`);
  const extraParams =
    config && config.urlParams ? `&${config.urlParams()}` : '';

  return `/auth/login/?next=${path}&is_temp=1${extraParams}`;
};

const withAuth = (loader, config) => (args) => {
  const { getState, authPromise, request } = args;

  const { url } = request;
  const { pathname, searchParams } = new URL(url);

  return authPromise.then(() => {
    const isLoggedIn = selectUser(getState());

    if (!isLoggedIn) {
      const redirectUrl = buildRedirectUrl(
        pathname,
        searchParams.toString(),
        config
      );
      return redirect(redirectUrl);
    }

    return loader(args);
  });
};

export default withAuth;
